<div #root class="menu-root">
  <div class="menu">
  </div>
  <ul>

<!--    <li #item *ngFor="let route of routes" [routerLinkActive]="['is-active']"  class="li-no-bullet">-->
    <li #item *ngFor="let route of routes" [ngClass]="{'is-active': route.active}" class="li-no-bullet">
      <a [routerLink]="route.href" (click)="menuClicked(route);">
        <fa-icon [icon]="getIcon(route)"></fa-icon>
        <span class="route-label"> {{ route.label  }} </span>
        <span class="lw-badge" *ngIf="route.badge > 0">{{ route.badge }}</span>
      </a>
    </li>
  </ul>
</div>
